import { nFormatter } from "utils/parseNumber";

import { ReactComponent as LikedIcon } from "components/icons/likeIcon.svg";
import { ReactComponent as UnlikedIcon } from "components/icons/unliked.svg";

export const LikeButton = (props: {
  liked: boolean;
  count: number;
  onClick: () => void;
}): JSX.Element => {
  return (
    <div className="likes">
      <button onClick={props.onClick}>
        {props.liked ? <LikedIcon /> : <UnlikedIcon />}
      </button>
      <div className="label">{nFormatter(props.count)}</div>
    </div>
  );
};
